import { render, staticRenderFns } from "./EditCashRegisterPage.vue?vue&type=template&id=16e52fd4"
import script from "./EditCashRegisterPage.vue?vue&type=script&lang=js"
export * from "./EditCashRegisterPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports